import type { ReactElement } from "react";
import { ActionIcon, ActionIconProps, Group, Stack, Text } from "@mantine/core";
import "./ActionIconGroup.css";
import choiceClasses from "components/UI/ChoiceActionIcon.module.css";

interface ActionIconGroupProps {
  iconSize?: string | number;
  items: { icon: ReactElement; label: string; value: string }[];
  labelFontSize?: string | number;
  onClick: (value: string) => void;
  size?: ActionIconProps["size"];
  value: string;
}

export const ActionIconGroup = (props: ActionIconGroupProps) => {
  const {
    iconSize,
    items,
    labelFontSize,
    onClick,
    value: selectedItemValue,
    size,
  } = props;

  return (
    <Group className="trkbk-action-button-group" grow wrap="nowrap">
      {items.map(({ icon, label, value }) => {
        const isSelected = value === selectedItemValue;

        return (
          <ActionIcon
            key={label}
            onClick={() => {
              onClick(value);
            }}
            size={size ?? 60}
            variant={isSelected ? "filled" : "transparent"}
            className={choiceClasses.choice}
            mod={{ selected: isSelected }}
          >
            {/* Centered: an icon narrower than its label would be at the left */}
            <Stack
              gap="xs"
              align="center"
              style={{
                fontSize: iconSize ?? "1.8rem",
                overflow: "hidden",
                padding: "5px",
              }}
            >
              {icon}
              <Text
                inline
                className="trkbk-action-button-label"
                style={{
                  maxWidth: "100%",
                  fontSize: labelFontSize ?? "0.8rem",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                {label}
              </Text>
            </Stack>
          </ActionIcon>
        );
      })}
    </Group>
  );
};
